import { Typography } from "@material-ui/core";
import classNames from "classnames";
import moment from "moment";
import { DefaultCard, useDefaultCardStyles } from "../../../../../components/cards/components";
import { MovimentacaoTransferenciaResponse } from "../../models/envio-movimentacao.model";
import { useStyles } from "../envio-movimentacao-listagem-styles";

interface MovimentacaoTransferenciaListaProps {
  listaTransferencia: MovimentacaoTransferenciaResponse[];
}

export const MovimentacaoTransferenciaLista: React.FC<MovimentacaoTransferenciaListaProps> = ({ listaTransferencia }) => {

  const styles = useStyles();
  const classesCard = useDefaultCardStyles();

  return (
    <div>
      {
        listaTransferencia?.map((row, index) => (

          <div className={`flex-column w-100 ${styles.cardMovimentacaoItem}`} key={index}>

            <DefaultCard className={styles.cardContainer}>

              <div className={`flex-row w-100 h-100`}>
                <div className={classNames(classesCard.tagStatus, styles.statusColor)} />

                <div className={`flex-row w-100 ${classesCard.infoContainer}`}>

                  <div className={`flex-column ${classesCard.inputMinWidth}`}>
                    <Typography className={classesCard.labelFont}>
                      Operação:
                    </Typography>
                    <Typography className={classesCard.contentFont}>
                      {row.operacao}
                    </Typography>
                  </div>

                  <div className={`flex-column ${classesCard.inputMinWidth}`}>
                    <Typography className={classesCard.labelFont}>
                      Data:
                    </Typography>
                    <Typography className={classesCard.contentFont}>
                      {moment(row.data).format("DD/MM/YYYY")}
                    </Typography>
                  </div>

                  <div className={`flex-column ${classesCard.inputMinWidth}`}>
                    <Typography className={classesCard.labelFont}>
                      Nº da NF:
                    </Typography>
                    <Typography className={classesCard.contentFont}>
                      {row.numeroNotaFiscal}
                    </Typography>
                  </div>

                  <div className={`flex-column ${classesCard.inputMinWidth}`}>
                    <Typography className={classesCard.labelFont}>
                      Origem:
                    </Typography>
                    <Typography className={classesCard.contentFont}>
                      {row.origem}
                    </Typography>
                  </div>

                  <div className={`flex-column ${classesCard.inputMinWidth}`}>
                    <Typography className={classesCard.labelFont}>
                      Destino:
                    </Typography>
                    <Typography className={classesCard.contentFont}>
                      {row.destino}
                    </Typography>
                  </div>
                </div>
              </div>

            </DefaultCard>

          </div>
        ))
      }
    </div>
  )
}